import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query'
import { useAuth } from 'react-oidc-context'

export function useSessionQuery<TData = unknown, TError = unknown>(
  options: Omit<UseQueryOptions<TData, TError>, 'enabled'> & {
    enabled?: boolean
  }
): UseQueryResult<TData, TError> {
  const { isAuthenticated } = useAuth()

  return useQuery({
    ...options,
    enabled: options.enabled !== false && isAuthenticated,
  })
}
